import { createTheme, darken } from '@mui/material/styles'

// Hoffmann Group corporate identity: orange (#FF7000), steel blue (#001D3F)
// and anthracite (#1D252D) — see the GARANT/HOLEX product design manuals.
const theme = createTheme({
    palette: {
        mode: 'light',
        primary: {
            main: '#FF7000',
            light: '#FF9640',
            dark: '#CC5A00',
            contrastText: '#ffffff',
        },
        secondary: {
            main: '#001D3F',
            light: '#2C4A73',
            dark: '#000E1F',
            contrastText: '#ffffff',
        },
        background: {
            default: '#f7f7f8',
            paper: '#ffffff',
        },
        text: {
            primary: '#1D252D',
            secondary: '#5C6470',
        },
    },
    typography: {
        fontFamily: ['Geist Mono'].join(','),
        fontSize: 12,
        button: {
            fontFamily: 'Geist Mono',
            fontSize: '12px',
            fontWeight: 300,
            textTransform: 'none',
            lineHeight: 1,
        },
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: ({ theme }) => ({
                    padding: '10px 24px',
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                    gap: '6px',
                    boxSizing: 'border-box',
                    '&:hover': { backgroundColor: theme.palette.primary.dark },
                    '&:active': { backgroundColor: darken(theme.palette.primary.dark, 0.2) },
                }),
                outlined: ({ theme }) => ({
                    border: `1px solid ${theme.palette.primary.main}`,
                    backgroundColor: 'transparent',
                    color: theme.palette.primary.main,
                    '&:hover': {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.primary.contrastText,
                        borderColor: 'transparent',
                    },
                }),
            },
        },
        MuiCard: {
            styleOverrides: {
                root: { borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.1)' },
            },
        },
        MuiCardContent: {
            styleOverrides: {
                root: { padding: '40px', '&:last-child': { paddingBottom: '40px' } },
            },
        },
        MuiMenuItem: {
            styleOverrides: {
                root: { fontSize: '12px' },
            },
        },
    },
})

export default theme
